import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import NotificationModalTypes from '../../enums/app/notificationModalTypes';
import {hideAllLoaders, setNotificationFailed, setNotificationInfo} from '../../state/ducks/global';
import {selectIotDeviceData, selectIsHolderConnected} from '../../state/selectors/iotDevice';
import {dispatch} from '../../state/store';
import {getState} from '../../state/store';
import elementsTesIds from '../../test/consts/elementsTesIds';
import connectivityService from '../device/connectivityService';
import deviceGlobalConfigService from '../iotDevice/iotDeviceGlobalConfigService';
import {getLocalizedStrings} from '../localization/localizationService';
import pairingService from '../pairingService';
import appRouterService from '../route/appRouterService';

//TODO: move to notificationService
const showDeviceSettingsGlobalError = () => {
    dispatch(setNotificationInfo(getLocalizedStrings()[localizationKeys.DEVICE_SETTINGS_GLOBAL_ERROR]));
};

const showError = (errorKey) => dispatch(setNotificationFailed(getLocalizedStrings()[errorKey]));

const showUpdateIsNeededNotification = (isHolderCheck) => {
    const localizedStrings = getLocalizedStrings();
    const iotDevice = selectIotDeviceData(getState());
    const isGlobalHolderCheck = deviceGlobalConfigService.isGlobalHolderCheck(iotDevice);

    if (isHolderCheck && isGlobalHolderCheck) {
        dispatch(
            setNotificationInfo(localizedStrings[localizationKeys.DEVICE_SETTINGS_UPDATE_HOLDER_NOTIFICATION_TEXT])
        );
    } else {
        dispatch(
            setNotificationInfo(localizedStrings[localizationKeys.DEVICE_SETTINGS_UPDATE_DEVICE_NOTIFICATION_TEXT])
        );
    }
};

const showConnectCareNotAvailableNotification = () => {
    const localizedStrings = getLocalizedStrings();

    dispatch(
        setNotificationInfo(
            localizedStrings[localizationKeys.TROUBLESHOOTING_CONSENT_DESCRIPTION_TEXT],
            elementsTesIds.DEVICE_SETTINGS_DIAGNOSTIC_NOT_AVAILABLE_NOTIFICATION
        )
    );
};

const showCleaningHolderDisconnectNotification = () => {
    const localizedStrings = getLocalizedStrings();

    dispatch(setNotificationInfo(localizedStrings[localizationKeys.CLEANING_UNPLUGGED_NOTIFICATION_TEXT]));
};

const showDeviceDisconnectNotification = (testId) => {
    prepareNotification(false, testId, NotificationModalTypes.DISCONNECT_DEVICE);
};

const showDeviceHolderDisconnectNotification = () => {
    prepareNotification(true);
};

const getNotificationMessageKey = (isHolder, isBle) => {
    if (isHolder) {
        return isBle
            ? localizationKeys.DEVICE_SETTINGS_INSERT_HOLDER_NOTIFICATION_TEXT
            : localizationKeys.USB_DEVICE_SETTINGS_INSERT_HOLDER_NOTIFICATION_TEXT;
    } else {
        return isBle
            ? localizationKeys.DEVICE_SETTINGS_CONNECT_NOTIFICATION_TEXT
            : localizationKeys.DEVICE_SETTINGS_CONNECT_VIA_USB_NOTIFICATION_TEXT;
    }
};

const prepareNotification = (isHolder, testId, type) => {
    const isReconnectDeviceGuideEnabled = appConfig.getIsReconnectDeviceGuideEnabled();
    const isBle = connectivityService.isBle();
    const messageKey = getNotificationMessageKey(isHolder, isBle);
    const isNotificationType =
        (isReconnectDeviceGuideEnabled || type === NotificationModalTypes.DISCONNECT_DEVICE) && isBle && !isHolder;

    let notificationType;

    if (isNotificationType) {
        notificationType = isReconnectDeviceGuideEnabled
            ? NotificationModalTypes.RECONNECT_DEVICE
            : NotificationModalTypes.DISCONNECT_DEVICE;
    } else {
        notificationType = null;
    }

    dispatch(setNotificationInfo(getLocalizedStrings()[messageKey], testId, notificationType));
};

const showGlobalError = () => {
    showError(localizationKeys.GLOBAL_ERROR_WITH_RETRY_DESCRIPTION_TEXT);
};

const showGlobalErrorWithAppHardReset = () => {
    showError(
        getBleOrUsbErrorKey(
            localizationKeys.GLOBAL_ERROR_NOTIFICATION_TEXT,
            localizationKeys.GLOBAL_ERROR_NOTIFICATION_CONNECT_TEXT
        )
    );
    pairingService.disconnectAndClearState();
    appRouterService.forwardToBrowserVerificationPage();
};

const showErrorWithAppReset = (errorKey) => {
    pairingService.disconnectAndForwardToMyDevicesPage();
    showError(errorKey);
    dispatch(hideAllLoaders());
};

const showGlobalErrorWithAppReset = () =>
    showErrorWithAppReset(
        getBleOrUsbErrorKey(
            localizationKeys.GLOBAL_ERROR_NOTIFICATION_TEXT,
            localizationKeys.GLOBAL_ERROR_NOTIFICATION_CONNECT_TEXT
        )
    );

const showIoErrorWithAppReset = () => {
    showErrorWithAppReset(
        getBleOrUsbErrorKey(
            localizationKeys.IO_ERROR_NOTIFICATION_TEXT,
            localizationKeys.IO_ERROR_USB_NOTIFICATION_TEXT
        )
    );
};

const showDeviceSettingsError = (isHolder) => {
    if (isHolder) {
        const isHolderConnected = selectIsHolderConnected(getState());

        if (!isHolderConnected) {
            showDeviceHolderDisconnectNotification();
        } else {
            showDeviceSettingsGlobalError();
        }
    } else {
        showDeviceSettingsGlobalError();
    }
};

const getBleOrUsbErrorKey = (bleKey, usbKey) => (connectivityService.isBle() ? bleKey : usbKey);

export default {
    showCleaningHolderDisconnectNotification,
    showConnectCareNotAvailableNotification,
    showDeviceDisconnectNotification,
    showDeviceHolderDisconnectNotification,
    showDeviceSettingsGlobalError,
    showGlobalError,
    showGlobalErrorWithAppHardReset,
    showGlobalErrorWithAppReset,
    showIoErrorWithAppReset,
    showDeviceSettingsError,
    showUpdateIsNeededNotification,
};
